import Device from 'models/Device';
import { atom } from 'recoil';

export const currentConfiguredDevice = atom<Device | null>({
  key: 'currentConfiguredDevice',
  default: null,
});
